exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wysywig[data-v-f6933a9c]{margin:50px 0 0}.products-dropdown[data-v-f6933a9c]{margin-top:40px}h3[data-v-f6933a9c]{line-height:30px;cursor:pointer;margin-bottom:30px}h3 img[data-v-f6933a9c]{width:30px;float:left}article[data-v-f6933a9c]{padding:0 10px 20px 0}.image img[data-v-f6933a9c]{width:200px;@media (min-width:1025px){width:300px;@media (min-width:894px){width:300px}}}article h4[data-v-f6933a9c]{text-align:center;font-size:14px;line-height:28px;@media (min-width:1025px){font-size:18px;line-height:28px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f6933a9c","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/frontend/js/components/Category.vue
// module id = uWW2
// module chunks = 1